import { AppVersion } from '@/types';
import Config from '@/config';
import { useUserStore } from './users';
import { useCardStore } from './cards';
import { useStoresStore } from './stores';

const clearOldKeys = () => {
  const envKey = Config.sessionKey;
  const currentKey = `${Config.sessionKey}@${AppVersion}`;

  const keys = Object.keys(localStorage).filter(
    (key) => key.includes(envKey) && key !== currentKey
  );

  keys.forEach((key) => {
    localStorage.removeItem(key);
  });
};

export const useGenericStore = () => {
  const userStore = useUserStore();
  const cardStore = useCardStore();
  const storesStore = useStoresStore();

  const resetStore = () => {
    cardStore.resetStore();
    userStore.resetStore();
    storesStore.resetStore();
  };

  return {
    resetStore,
  };
};

clearOldKeys();
